import React from 'react';
import { Create, SimpleForm, TextInput, required } from 'react-admin';
import { CreateToolbar } from '../../../components/Toolbar/CreateToolbar';

export const CategoriesCreate = (props) => {
	return (
		<>
			<Create {...props} title='Create Category'>
				<SimpleForm variant='standard' margin='normal' toolbar={<CreateToolbar />}>
						<TextInput source='name' validate={required()} fullWidth />	
						<TextInput source='description' label='Description' multiline fullWidth />
				</SimpleForm>
			</Create>
		</>
	);
}